import { BaseModel } from '../base-model';
export interface IAppointmentStatusParameterModel {

}

export class AppointmentStatusParameterModel extends BaseModel<IAppointmentStatusParameterModel> implements IAppointmentStatusParameterModel {

  /**
   *
   */
  constructor(options?: { [key: string]: any }) {
    super(options);
  }
}

